// This is because current eslint and prettier do not line up with escaped strings in react
/* eslint-disable react/jsx-one-expression-per-line */
import * as React from 'react';
import RefereePageLayout from '../../layouts/RefereePageLayout';

const RefereeThanks = () => {
	return (
		<RefereePageLayout className="refereeThanksPage" title="Thanks">
			<h1>Thanks!</h1>
			<p>We appreciate you taking the time to complete this reference.</p>
			<br />
			<p>
				<strong>Let us save you time by referencing your next two hires for free with VETTING.com!</strong>
				<br />
				<a href="https://vetting.com/request-demo">Request a demo</a> and we&#39;ll be happy to show you how.
				<br />
				<br />
				<p>
					<a href="https://vetting.com">VETTING.com</a>
				</p>
			</p>
		</RefereePageLayout>
	);
};

export default RefereeThanks;
